export const POLAND_BOUNDS = {
    latMin: 49.0,
    latMax: 55.0,
    lngMin: 14.0,
    lngMax: 24.2
};

export const isWithinPoland = (lat: number, lng: number): boolean =>
    lat >= POLAND_BOUNDS.latMin && lat <= POLAND_BOUNDS.latMax && lng >= POLAND_BOUNDS.lngMin && lng <= POLAND_BOUNDS.lngMax;
export const POLAND_BOUNDS = {
    latMin: 49.0,
    latMax: 55.0,
    lngMin: 14.0,
    lngMax: 24.2
};

export const isWithinPoland = (lat: number, lng: number): boolean =>
    lat >= POLAND_BOUNDS.latMin && lat <= POLAND_BOUNDS.latMax && lng >= POLAND_BOUNDS.lngMin && lng <= POLAND_BOUNDS.lngMax;
